import React, { useEffect, useRef, useState } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import CommunitySelectLoader from './CommunitySelectLoader';
import './CommunitySelectModal.css';
import {
  CallToActionPrimary,
  CallToActionSecondary
} from '../CallToAction/CallToAction';

const CommunitySelectModal = ({
  communities,
  onClose,
  onCommunitySelect,
  communitiesLoading
}) => {
  const communitySelectModalRef = useRef();
  const [communitySelected, selectCommunity] = useState();

  const cancelAndClose = () => {
    selectCommunity(undefined);
    onClose(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        communitySelectModalRef.current &&
        !communitySelectModalRef.current.contains(event.target)
      ) {
        cancelAndClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [communitySelectModalRef]);

  const selectCommunityAndClose = () => {
    onCommunitySelect(communitySelected);
    selectCommunity(undefined);
    onClose(false);
  };
  return (
    <div styleName="container" ref={communitySelectModalRef}>
      <span styleName="text">{i18next.t('postInMultipleComminities')}</span>
      {communitiesLoading && <CommunitySelectLoader />}
      {!communitiesLoading && (
        <div styleName="options">
          {Object.keys(communities).map((communityKey) => (
            <button
              key={communities[communityKey].id}
              styleName={`option ${
                communityKey === communitySelected ? 'option-selected' : ' '
              }`}
              onClick={() => selectCommunity(communityKey)}
              type="button"
            >
              <Icon fixedWidth color="#4F4F4F" icon={['fa', 'users']} />
              <span styleName="text-button">
                {communities[communityKey].name}
              </span>
            </button>
          ))}
        </div>
      )}
      <div styleName="wrapper">
        <CallToActionSecondary
          label={i18next.t('cancel', 'cancel')}
          size="small"
          onClick={cancelAndClose}
        />
        <CallToActionPrimary
          label={i18next.t('confirm', 'confirm')}
          size="small"
          isDisabled={!communitySelected}
          onClick={selectCommunityAndClose}
        />
      </div>
    </div>
  );
};

CommunitySelectModal.propTypes = {
  communities: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onCommunitySelect: PropTypes.func.isRequired,
  communitiesLoading: PropTypes.bool
};

CommunitySelectModal.defaultProps = {
  communitiesLoading: false
};

export default CommunitySelectModal;
